"use client";

// HubSpot visitor tracking.
//
// Client-side for the same reason as every other tag here — see adminRoute.
import Script from "next/script";
import { hubspotSrc, isTrackingHost } from "@/lib/tracking";
import { useIsAdminRoute } from "./adminRoute";

export function HubSpotScript({ portalId }: { portalId: string }) {
  const onAdmin = useIsAdminRoute();
  // next/script injects this after hydration, so unlike the inline snippets it
  // can be decided by not rendering it at all.
  if (!portalId || onAdmin || !isTrackingHost()) return null;
  return (
    <Script
      // HubSpot's own code looks this element up by id — keep it.
      id="hs-script-loader"
      strategy="afterInteractive"
      src={hubspotSrc(portalId)}
    />
  );
}
